/**
 * Entry application component used to compose providers and render Routes.
 * */

import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, useHistory } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { AuthInit } from "./modules/Auth";
import Routes from "./routes";
import { I18nProvider } from "../_metronic/i18n";
import { LayoutSplashScreen, MaterialThemeProvider } from "../_metronic/layout";
import {
  QueryClientProvider,
  QueryClient,
  useQuery,
  useQueryClient,
} from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ToastContainer } from "react-toastify";
import AppStyle from "./components/wrapper/AppStyle";
import setupAxios from "../redux/setupAxios";
import axios from "axios";

export default function App({
  store,
  persistor,
  basename,
}: {
  store: any;
  persistor: any;
  basename: any;
}) {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
        refetchOnWindowFocus: false,
        cacheTime: Infinity,
      },
    },
  });
  useEffect(() => {
    setupAxios(axios);
  }, []);
  return (
    <>
      <ToastContainer
        rtl={true}
        closeButton={false}
        pauseOnHover={true}
        position={"top-center"}
        newestOnTop={true}
        limit={3}
      />
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
          <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
            {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
            <React.Suspense fallback={<LayoutSplashScreen />}>
              {/* Override `basename` (e.g: `homepage` in `package.json`) */}
              <BrowserRouter basename={basename}>
                {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
                <MaterialThemeProvider>
                  {/* Provide `react-intl` context synchronized with Redux state.  */}
                  <I18nProvider>
                    {/* Render routes with provided `Layout`. */}
                    <AuthInit>
                      <AppStyle>
                        <Routes />
                      </AppStyle>
                    </AuthInit>
                  </I18nProvider>
                </MaterialThemeProvider>
              </BrowserRouter>
            </React.Suspense>
          </PersistGate>
        </Provider>
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      </QueryClientProvider>
    </>
  );
}
